import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { IPermissionProps } from "../../models/Login";
import { IModel } from "./BranchInvoicePercentageMatrix";
import { History } from "./History";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter, IFilter } from "./Filter";
import { Toolbar } from "primereact/toolbar";

export interface IBranchInvoiceMatrix {
    id?: number,
    sales_Branch_ID?: number,
    sales_Company?: string,
    sales_Branch?: string,
    sales_Percentage?: number,
    recruiter_Branch_ID?: number,
    recruiter_Company?: string,
    recruiter_Branch?: string,
    recruiter_Percentage?: number,
}

export const emptyForm: IBranchInvoiceMatrix = {
    id: 0,
    sales_Branch_ID: 0,
    sales_Percentage: 0,
    recruiter_Branch_ID: 0,
    recruiter_Percentage: 0
}

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBranchInvoiceMatrix>, loading: boolean });
    const [openHistory, setOpenHistory] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IBranchInvoiceMatrix });
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [filter, setFilter] = useState<IFilter>({});
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    useEffect(() => {
        loadTableData();
    }, [filter, lazyParams, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/getBrancIncPercentage", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(filter)}`, props.toast);
        if (response) {
            const data: { list: Array<IBranchInvoiceMatrix>, totalRecords: number } = await response.json();
            setTotalRecords(data.totalRecords);
            setTableData({ tableData: data.list, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const openEdit = (rowDatauser: IBranchInvoiceMatrix) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Branches Share Percentage</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span> */}
        </div>
    );

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        );
    };

    const actionBodyTemplate = (rowData: IBranchInvoiceMatrix) => {
        return (
            <div className="actions">
                {props.permissions.is_Update && <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />}
                <Button icon="pi pi-history" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => setOpenHistory({ open: true, singleData: rowData })} />
            </div>
        );
    };

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filter} setFilters={setFilter} loading={tableData.loading} />
                </AccordionTab>
            </Accordion>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" scrollable
                value={tableData.tableData}
                stripedRows showGridlines
                emptyMessage="No Branches Share found."
                header={header}
                loading={tableData.loading} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: "5rem" }} />
                <Column field="sales_Company" header="Sales Company" sortable />
                <Column field="sales_Branch" header="Sales Branch" sortable />
                <Column field="sales_Percentage" header="Sales Share Percentage" />
                <Column field="recruiter_Company" header="Recruiter Company" sortable />
                <Column field="recruiter_Branch" header="Recruiter Branch" sortable />
                <Column field="recruiter_Percentage" header="Recruiter Share Percentage" />
                <Column header="Action" body={actionBodyTemplate} />
            </DataTable>
            <History singleData={openHistory.singleData} open={openHistory.open} hideDialog={() => setOpenHistory({ open: false, singleData: {} })} toast={props.toast} reload={props.reload} />
        </>
    );
}